module.exports = __webpack_public_path__ + "img/Report-icon.821c2fdc.svg";